export const onlyLettersReg = /^[a-zа-яё]+$/gi;
